import React from 'react';
import { NavLink, useLocation } from 'react-router-dom'; // Import NavLink for active navigation
import './FooterNav.css';

// Import custom icons
import dictionaryActive from '../assets/activeDictionary.svg';
import dictionaryInactive from '../assets/inactiveDictionary.svg';
import homeActive from '../assets/activeHome.svg';
import homeInactive from '../assets/inactiveHome.svg';
import profileActive from '../assets/activeProfile.svg';
import profileInactive from '../assets/inactiveProfile.svg';

export default function FooterNav() {
  const location = useLocation();
  
  return (
    <footer className="footer-nav shadow-sm d-flex justify-content-around h-10">
      <div className="nav-item">
        <NavLink
          to="/dictionary" // Navigate to the dictionary route
          className="nav-link d-flex flex-column align-items-center"
          // activeClassName="active"
          
          // exact
        >
          <img
            src={/^(\/dictionary|\/brand|\/molecule)/.test(location.pathname) ? dictionaryActive : dictionaryInactive}
            alt="Dictionary"
            width={24}
            height={24}
          />
          {/^(\/dictionary|\/brand|\/molecule)/.test(location.pathname)  && <div className="smallGreenDot"></div>}
        </NavLink>
      </div>

      <div className="nav-item">
        <NavLink
          to="/home" // Navigate to the home route
          className="nav-link d-flex flex-column align-items-center"
          // activeClassName="active"
          // exact
        > 
          <img
            src={/^(\/home|\/yourLearning)/.test(location.pathname) ? homeActive : homeInactive}
            alt="Home"
            width={24}
            height={24}
          />
          {/^(\/home|\/yourLearning)/.test(location.pathname) && <div className="smallGreenDot"></div>}
        </NavLink>
      </div>

      <div className="nav-item">
        <NavLink
          to="/profile" // Navigate to the profile route
          className="nav-link d-flex flex-column align-items-center"
          // activeClassName="active"
          // exact
        >
          <img
            src={ /^(\/profile)/.test(location.pathname) ? profileActive : profileInactive}
            alt="Profile"
            width={24}
            height={24}
          />
          {location.pathname === '/profile' && <div className="smallGreenDot"></div>}
        </NavLink>
      </div>
    </footer>
  );
}
